// Plays remote attendee audio. Rendered once per remote attendee; attach via
// ref effect, keyed by identity + track epoch (same §9.3.4 pattern as video).

import { memo, useEffect, useRef } from 'react';

import { engine } from '../engine';
import { useCallStore, useCallStoreShallow } from '../store/callStore';

const AudioSink = memo(function AudioSink({ identity }: { identity: string }) {
  const micEnabled = useCallStore((s) => s.attendees[identity]?.micEnabled ?? false);
  const trackEpoch = useCallStore((s) => s.trackEpochs[identity] ?? 0);
  const ref = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const track = engine.audioTrack(identity);
    if (!track) return;
    track.attach(el);
    return () => {
      track.detach(el);
    };
  }, [identity, micEnabled, trackEpoch]);

  return <audio ref={ref} autoPlay />;
});

export function RemoteAudio() {
  const remoteIds = useCallStoreShallow((s) => s.order.filter((id) => !s.attendees[id]?.isLocal));
  return (
    <div hidden>
      {remoteIds.map((id) => (
        <AudioSink key={id} identity={id} />
      ))}
    </div>
  );
}
